import { apiClient } from "@/api";
import { ApiResponse, PaginatedData } from "@/types";
import type { AxiosRequestConfig } from "axios";

export type ICategory = "ai_use_case" | "ax_trend" | "pwc_digital_solutions";
export interface IGetListArticlesReq {
  category: ICategory;
  page: number;
  page_size: number;
}

export interface IGetListArticlesRes {
  id: string;
  title:string;
  category: ICategory;
  cover_image_url: string;
  content: string;
  created_at: string;
}
export const AXNewsService = {
  getListByArticles: (params: IGetListArticlesReq, config?: AxiosRequestConfig) => {
    return apiClient.get<ApiResponse<PaginatedData<IGetListArticlesRes>>>('ax-trend-hub/articles', { ...config, params })
  },
  getArticleDetail: (id:string, config?: AxiosRequestConfig) => {
    return apiClient.get<ApiResponse<IGetListArticlesRes>>(`ax-trend-hub/articles/${id}`, config)
  }
};
